/**
 * About Page Translations
 * =======================
 */

import { Translations } from '../shared/i18n';

export const aboutTranslations: Translations = {
  en: {
    aboutSeoTitle: "KontoMatch | About Us",
    aboutSeoDesc:
      "KontoMatch is an AI-powered bank reconciliation tool built by founders in Zurich and Berlin. Automatically match invoices to bank statements — no accountant needed.",

    aboutLogoAlt: "Gordian Analytics logo",
    aboutEyebrow: "About KontoMatch",
    aboutTitle: "Built by Founders Who Hated Bookkeeping",

    aboutP1Before:
      "We've been running our own companies for over a decade, one in Zurich, one in Berlin, and our joint startup,",
    aboutP1After:
      ". And every single month, across all our businesses, we faced the exact same headache: sorting endless invoices, cross-checking bank statements, figuring out which payment belonged to which receipt, and constantly dealing with currency conversions.",

    aboutP2:
      "We tried every tool out there. Expense trackers, traditional accounting software, and complex spreadsheet templates. They all helped with parts of the problem, but none of them solved the real bottleneck: seamlessly matching your documents to your bank statement.",

    aboutH2Story: "From Internal Tool to Tax-Ready Bookkeeping",
    aboutP3:
      "So, we built KontoMatch for ourselves. Initially, it was strictly an internal tool to manage our own receipts, sync our own bank statements, and get everything perfectly prepped for our Steuerberater.",
    aboutP4:
      "For months, we stress-tested it. Once it worked, and really worked, the decision was obvious. We knew other founders, freelancers, and small businesses in the DACH region faced this exact same monthly struggle. You don't just need another expense tracker, you need a system that actually matches the data.",
    aboutP5: "That's why KontoMatch exists.",

    aboutH2Location: "Where We Are",
    aboutP6:
      "KontoMatch is proudly built between Zurich and Berlin. Two cities, two founders, one shared mission: to make monthly bookkeeping painless.",

    aboutContactHeading1: "Got an idea, feedback, or a question?",
    aboutContactHeading2: "We read everything.",
    aboutContactSuccess: "Thanks for reaching out! We'll get back to you soon.",

    aboutFormName: "Name",
    aboutFormEmail: "Email",
    aboutFormMessage: "Message",
    aboutFormSubmit: "Send Message",
    aboutFormSubmitting: "Sending...",

    aboutFormErrRequired: "Please fill in all fields.",
    aboutFormErrEmail: "Please enter a valid email address.",
    aboutFormErrGeneric: "Something went wrong. Please try again later.",
  },

  de: {
    aboutSeoTitle: "KontoMatch | Über uns",
    aboutSeoDesc:
      "KontoMatch ist ein KI-gestütztes Tool zum Bankabgleich, entwickelt von Gründern in Zürich und Berlin. Rechnungen automatisch mit dem Kontoauszug abgleichen — ohne Buchhalter.",

    aboutLogoAlt: "Gordian-Analytics-Logo",
    aboutEyebrow: "Über KontoMatch",
    aboutTitle: "Gebaut von Gründern, die Buchhaltung hassten",

    aboutP1Before:
      "Wir führen seit über einem Jahrzehnt unsere eigenen Unternehmen. eines in Zürich, eines in Berlin und unser gemeinsames Startup,",
    aboutP1After:
      ". Und jeden einzelnen Monat, in allen unseren Unternehmen, hatten wir dasselbe Problem: endlose Rechnungen sortieren, Kontoauszüge abgleichen, herausfinden, welche Zahlung zu welchem Beleg gehört, und ständig mit Währungsumrechnungen kämpfen.",

    aboutP2:
      "Wir haben jedes Tool ausprobiert: Ausgaben-Tracker, klassische Buchhaltungssoftware, komplexe Tabellenvorlagen. Sie halfen alle bei Teilproblemen, aber keines löste den eigentlichen Engpass: das nahtlose Abgleichen deiner Dokumente mit deinem Kontoauszug.",

    aboutH2Story: "Vom internen Tool zur steuerfertige Buchhaltung",
    aboutP3:
      "Also haben wir KontoMatch für uns selbst gebaut. Anfangs war es ein streng internes Tool, um unsere eigenen Belege zu verwalten, Kontoauszüge zu synchronisieren und alles perfekt für unseren Steuerberater vorzubereiten.",
    aboutP4:
      "Monatelang haben wir es getestet. Als es wirklich funktionierte, war die Entscheidung klar. Wir wussten, dass andere Gründer, Freelancer und KMUs in der DACH-Region denselben monatlichen Kampf haben. Du brauchst nicht noch einen Ausgaben-Tracker. du brauchst ein System, das die Daten wirklich zusammenführt.",
    aboutP5: "Deshalb gibt es KontoMatch.",

    aboutH2Location: "Wo wir sind",
    aboutP6:
      "KontoMatch wird mit Stolz zwischen Zürich und Berlin entwickelt. Zwei Städte, zwei Gründer, eine gemeinsame Mission: monatliche Buchhaltung endlich schmerzlos machen.",

    aboutContactHeading1: "Eine Idee, Feedback oder eine Frage?",
    aboutContactHeading2: "Wir lesen alles.",
    aboutContactSuccess: "Danke für deine Nachricht! Wir melden uns bald.",

    aboutFormName: "Name",
    aboutFormEmail: "E-Mail",
    aboutFormMessage: "Nachricht",
    aboutFormSubmit: "Nachricht senden",
    aboutFormSubmitting: "Wird gesendet...",

    aboutFormErrRequired: "Bitte fülle alle Felder aus.",
    aboutFormErrEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
    aboutFormErrGeneric:
      "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
  },

  tr: {
    aboutSeoTitle: "KontoMatch | Hakkımızda",
    aboutSeoDesc:
      "KontoMatch, Zürih ve Berlin'deki kurucular tarafından muhasebe açısından en büyük sorunu çözmek için inşa edildi: makbuzları banka ekstrelerine mükemmel şekilde eşleştirmek.",

    aboutLogoAlt: "Gordian Analytics logosu",
    aboutEyebrow: "KontoMatch Hakkında",
    aboutTitle: "Muhasebeyi Sevmeyen Kurucular Tarafından İnşa Edildi",

    aboutP1Before:
      "On yılı aşkın süredir kendi şirketlerimizi yönetiyoruz. biri Zürih'te, biri Berlin'de ve ortak girişimimiz",
    aboutP1After:
      ". Her ay, tüm işletmelerimizde aynı baş ağrısıyla karşılaştık: sonsuz faturaları tasnif etmek, banka ekstrelerini çapraz kontrol etmek, hangi ödemenin hangi makbuza ait olduğunu çözmek ve sürekli döviz dönüşümleriyle uğraşmak.",

    aboutP2:
      "Piyasadaki her aracı denedik: harcama takipçileri, geleneksel muhasebe yazılımları, karmaşık elektronik tablo şablonları. Hepsi sorunun bir kısmına yardımcı oldu, ancak hiçbiri asıl darboğazı çözmedi: belgelerini banka ekstresiyle kusursuz şekilde eşleştirmek.",

    aboutH2Story: "Dahili Araçtan Vergiye Hazır Muhasebeye",
    aboutP3:
      "Bu yüzden KontoMatch'yu kendimiz için inşa ettik. Başlangıçta yalnızca kendi makbuzlarımızı yönetmek, kendi banka ekstrelerimizi senkronize etmek ve her şeyi Steuerberater'imize mükemmel şekilde hazırlamak için dahili bir araçtı.",
    aboutP4:
      "Aylarca test ettik. Gerçekten işe yaradığında karar açıktı. DACH bölgesindeki diğer kurucuların, serbest çalışanların ve KOBİ'lerin aynı aylık mücadeleyle karşılaştığını biliyorduk. Başka bir harcama takipçisine değil, verileri gerçekten eşleştiren bir sisteme ihtiyacın var.",
    aboutP5: "KontoMatch bunun için var.",

    aboutH2Location: "Neredeyiz",
    aboutP6:
      "KontoMatch, Zürih ile Berlin arasında gururla inşa edilmektedir. İki şehir, iki kurucu, tek ortak misyon: aylık muhasebeyi acısız hale getirmek.",

    aboutContactHeading1: "Bir fikrin, geri bildiriminiz veya sorunuz mu var?",
    aboutContactHeading2: "Her şeyi okuyoruz.",
    aboutContactSuccess:
      "İletişime geçtiğin için teşekkürler! En kısa sürede geri döneceğiz.",

    aboutFormName: "Ad",
    aboutFormEmail: "E-posta",
    aboutFormMessage: "Mesaj",
    aboutFormSubmit: "Mesaj Gönder",
    aboutFormSubmitting: "Gönderiliyor...",

    aboutFormErrRequired: "Lütfen tüm alanları doldur.",
    aboutFormErrEmail: "Lütfen geçerli bir e-posta adresi gir.",
    aboutFormErrGeneric:
      "Bir şeyler ters gitti. Lütfen daha sonra tekrar dene.",
  },
};
